import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { PrescriptionApi } from '../../../apis/PrescriptionApi/PrescriptionApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IUnlockPrescriptionsRequest, PrescriptionData } from '../Prescription';

export function useUnlockPrescriptions(patientId?: string | number) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<PrescriptionData, AppMedError, IUnlockPrescriptionsRequest>({
        mutationKey: [QueryKeys.prescription, 'unlock'],
        mutationFn: async (request) => {
            return await PrescriptionApi.unlockPrescriptions(request);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.prescription] });
            if (patientId != null)
                queryClient.invalidateQueries({ queryKey: [QueryKeys.prescriptionActivity, String(patientId)] });

            notifications.show({
                title: t('prescriptionHistory.notifications.unlockSuccess.title'),
                message: t('prescriptionHistory.notifications.unlockSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('prescriptionHistory.notifications.unlockError.title'),
                message: error?.message || t('prescriptionHistory.notifications.unlockError.message'),
                color: 'red',
            });
        },
    });
}
